module.exports = __webpack_public_path__ + "static/chemical-complete-ad0ce1f5a3366ceb6cfe7fe81e886fcd.jpg";